import store from '@/store/store'
import Firebase from 'firebase'
import 'firebase/firestore'
import router from '@/routes'

const config = {
  apiKey: "AIzaSyBZhAsSxet9NRqYzQajGrsdxVXklpvMDIw",
  authDomain: "consilium-c139e.firebaseapp.com",
  databaseURL: "https://consilium-c139e.firebaseio.com",
  projectId: "consilium-c139e",
  storageBucket: "consilium-c139e.appspot.com",
  messagingSenderId: "200947524504",
  appId: "1:200947524504:web:d7cc7c49acefb055b081ed",
  measurementId: "G-8ZX9EK3RN0"
}

export default {
  install: (Vue) => {
    const firebase = Firebase.initializeApp(config)
    firebase.analytics().logEvent('screen_view');
    const auth = firebase.auth()
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        return await auth.signInWithEmailAndPassword(username, pass)
      },
      logout: async () => {
        await auth.signOut() 
      }
    } 
    auth.onAuthStateChanged(user => {
      store.commit('updateUser',{ user })
      store.dispatch('fetchUserData')
      Firebase.firestore().collection('users').doc(user.uid).get().then((doc) => {
        if (!doc.data().profile) {
          router.push('/profile/' + user.uid)
        }
      })
    })
  }
}